import EditInvestmentOrWithdrawalPlan from './EditPlanContainer';

export default EditInvestmentOrWithdrawalPlan;